import ModelListItem from './ModelListItem';

import './ModelListItem.scss';

export default ModelListItem;
